import React from 'react';
import { Button, Form, FormGroup, Input, Label } from '../../components/Bootstrap';
import { AuthContext } from '../../AuthService';
const Logo = require('./Logo.svg');

interface ForgotPasswordProps {
  auth: any;
  onSubmit(email: string);
}

class ForgotPasswordUnwrapped extends React.Component<ForgotPasswordProps, any> {
  constructor(props) {
    super(props);
    this.state = { email: '', loading: false, error: null, sent: false };

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleEmailChange(event) {
    this.setState({ email: event.target.value });
  }

  async handleSubmit(event) {
    event.preventDefault();

    this.setState({ loading: true });
    try {
      await this.props.auth.resetPassword(this.state.email);
      this.setState({ sent: true });
    } catch (error) {
      this.setState({
        loading: false,
        error,
      });
    }
  }

  render() {
    return (
      <div className='centered-block login-card'>
        <Form onSubmit={this.handleSubmit} method='post'>
          <img src={Logo} alt='Noble' className='login-card-logo' />
          <p>{this.state.error && 'Bad username / password'}</p>
          {this.state.sent && <p>Sent! Check your email to setup a new password</p>}
          <FormGroup>
            <Label for='username'>Email</Label>
            <Input name='username' id='username' onChange={this.handleEmailChange} className='login-input' />
          </FormGroup>
          <div className='text-center'>
            <Button className='btn--rounded ps-4 pe-4' color='primary' type='submit' disabled={this.state.loading}>
              Reset
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

export const ForgotPassword = (props) => {
  return <AuthContext.Consumer>{(auth) => <ForgotPasswordUnwrapped {...props} auth={auth} />}</AuthContext.Consumer>;
};
